import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';
import BillingOverviewValueRow from './BillingOverviewValueRow';

export const AvailableToBillValueRowGroup = ({
  sectionData,
  expanded,
  onExpandChange,
  displayTotalColumn
}) => {
  const { amountTotal, billPlans, loading } = sectionData;

  return (
    <>
      <BillingOverviewValueRow
        rowTitle="billingOverviewTable.availableToBill"
        rowData={amountTotal}
        expanded={expanded}
        onExpandChange={onExpandChange}
        totalRow
        collapsibleHeader
        displayTotalColumn={displayTotalColumn}
        useCellBorderClass
      />
      {loading && expanded ? (
        <Skeleton variant="rect" width="80%" height={30} />
      ) : (
        expanded &&
        Object.keys(billPlans).map(bpKey => (
          <BillingOverviewValueRow
            key={bpKey}
            subRow
            rowData={billPlans[bpKey]}
            rowTitle={billPlans[bpKey].displayText}
            displayTotalColumn={displayTotalColumn}
            dataQeId={`availableToBillSection.${bpKey}`}
          />
        ))
      )}
    </>
  );
};

AvailableToBillValueRowGroup.propTypes = {
  sectionData: PropTypes.object,
  expanded: PropTypes.bool,
  onExpandChange: PropTypes.func,
  displayTotalColumn: PropTypes.bool
};

export default AvailableToBillValueRowGroup;
